// export const NODE_API = 'http://localhost:5000';

export const NODE_API = 'https://landnest.net:7000';